import { createAction } from 'redux-actions';

const action = createAction('SET_DIRTY_ON_TAB_REGAIN_VISIBILITY');
export const setDataForMessageRefreshDirty = () => action();
